import { VehicleAccidentsOperationId } from '@mapfre/vehicle-accidents';

const VEHICLE_ACCIDENTS_OPERATIONS: [
  VehicleAccidentsOperationId,
  { operationCode: string }
][] = [
  [
    VehicleAccidentsOperationId.seleccion_lunas,
    { operationCode: '88513' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_sin_contrario,
    { operationCode: '88514' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_con_contrario,
    { operationCode: '88515' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_danos_cargador,
    { operationCode: '89371' }
  ],
  [
    VehicleAccidentsOperationId.inicio,
    { operationCode: '88081' }
  ],
  [
    VehicleAccidentsOperationId.tipo_no_disponible,
    { operationCode: '88084' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_tipo,
    { operationCode: '88085' }
  ],
  [
    VehicleAccidentsOperationId.prestamo,
    { operationCode: '88510' }
  ],
  [
    VehicleAccidentsOperationId.guardar,
    { operationCode: '88511' }
  ],
  [
    VehicleAccidentsOperationId.abandono_sin_contrario,
    { operationCode: '88512' }
  ],
  [
    VehicleAccidentsOperationId.otros_danos_presentes,
    { operationCode: '88516' }
  ],
  [
    VehicleAccidentsOperationId.danos_solo_vehiculo,
    { operationCode: '88517' }
  ],
  [
    VehicleAccidentsOperationId.golpe_unico,
    { operationCode: '88518' }
  ],
  [
    VehicleAccidentsOperationId.golpes_acumulados,
    { operationCode: '88519' }
  ],
  [
    VehicleAccidentsOperationId.datos_generales_siniestro,
    { operationCode: '88520' }
  ],
  [
    VehicleAccidentsOperationId.datos_danos_vehiculo,
    { operationCode: '88521' }
  ],
  [
    VehicleAccidentsOperationId.datos_danos_adicionales,
    { operationCode: '88522' }
  ],
  [
    VehicleAccidentsOperationId.resumen_datos,
    { operationCode: '88523' }
  ],
  [
    VehicleAccidentsOperationId.datos_contacto,
    { operationCode: '88524' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_tipo_taller_continuo,
    { operationCode: '88525' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_tipo_taller_diferido,
    { operationCode: '88557' }
  ],
  [
    VehicleAccidentsOperationId.centro_servicio_continuo,
    { operationCode: '88527' }
  ],
  [
    VehicleAccidentsOperationId.centro_servicio_diferido,
    { operationCode: '88543' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_vehiculo_cortesia_ok_continuo,
    { operationCode: '88537' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_vehiculo_cortesia_ok_diferido,
    { operationCode: '88555' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_pendiente_confirmacion_culpa_ok_continuo,
    { operationCode: '89606' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_pendiente_confirmacion_culpa_ok_diferido,
    { operationCode: '89608' }
  ],
  [
    VehicleAccidentsOperationId.taller_distinguido_continuo,
    { operationCode: '88528' }
  ],
  [
    VehicleAccidentsOperationId.taller_distinguido_diferido,
    { operationCode: '88544' }
  ],
  [
    VehicleAccidentsOperationId.otro_taller_continuo,
    { operationCode: '88530' }
  ],
  [
    VehicleAccidentsOperationId.otro_taller_diferido,
    { operationCode: '88546' }
  ],
  [
    VehicleAccidentsOperationId.abandono_reparacion,
    { operationCode: '88559' }
  ],
  [
    VehicleAccidentsOperationId.ro_op_024,
    { operationCode: '88529' }
  ],
  [
    VehicleAccidentsOperationId.ro_op_044,
    { operationCode: '88545' }
  ],
  [
    VehicleAccidentsOperationId.sin_contrario_OB_aparcamiento_ok,
    { operationCode: '88536' }
  ],
  [
    VehicleAccidentsOperationId.sin_contrario_OB_circulacion_ok,
    { operationCode: '88535' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_ok_continuo,
    { operationCode: '88539' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_otro_taller_ok_continuo,
    { operationCode: '88542' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_taller_pap_ok_continuo,
    { operationCode: '88541' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_taller_distinguido_ok_continuo,
    { operationCode: '88540' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_ok_diferido,
    { operationCode: '88547' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_otro_taller_ok_diferido,
    { operationCode: '88553' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_taller_pap_ok_diferido,
    { operationCode: '88551' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_taller_distinguido_ok_diferido,
    { operationCode: '88549' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_vehiculo_cortesia_ok_diferido,
    { operationCode: '88555' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OB_contacto_enviado_ok,
    { operationCode: '88027' }
  ],
  [
    VehicleAccidentsOperationId.sin_contrario_OI_pdf_ko,
    { operationCode: '88561' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OI_poliza_no_en_vigor,
    { operationCode: '88400' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OI_siniestro_existe_a_fecha,
    { operationCode: '88401' }
  ],
  [
    VehicleAccidentsOperationId.OE_error_servicio,
    { operationCode: '88083' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_ko_continuo,
    { operationCode: '88531' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_ko_diferido,
    { operationCode: '88548' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_vehiculo_cortesia_ko_continuo,
    { operationCode: '88556' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_vehiculo_cortesia_ko_diferido,
    { operationCode: '88538' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_pendiente_confirmacion_culpa_ko_continuo,
    { operationCode: '89607' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_pendiente_confirmacion_culpa_ko_diferido,
    { operationCode: '89609' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_otro_taller_ko_continuo,
    { operationCode: '88534' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_otro_taller_ko_diferido,
    { operationCode: '88554' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_taller_distinguido_ko_continuo,
    { operationCode: '88532' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_taller_distinguido_ko_diferido,
    { operationCode: '88550' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_taller_pap_ko_continuo,
    { operationCode: '88533' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_taller_pap_ko_diferido,
    { operationCode: '88552' }
  ],
  [
    VehicleAccidentsOperationId.OE_apertura_ko,
    { operationCode: '88560' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_motor_reglas_ko_continuo,
    { operationCode: '89151' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_motor_reglas_ko_diferido,
    { operationCode: '89150' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_seleccion_tipo_taller_ko_continuo,
    { operationCode: '88526' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_seleccion_tipo_taller_ko_diferido,
    { operationCode: '88558' }
  ],
  [
    VehicleAccidentsOperationId.sin_contrario_OE_error_generico,
    { operationCode: '88507' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OE_servicio_balanceo_ko,
    { operationCode: '88026' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OE_error_contacto_enviado,
    { operationCode: '88028' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_error_generico,
    { operationCode: '88506' }
  ],
  [
    VehicleAccidentsOperationId.danos_cargador_OB_ok,
    { operationCode: '89372' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_pap_distinguido_sin_servicio,
    { operationCode: '89592' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_pap_continuo_sin_servicio,
    { operationCode: '89593' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_otros,
    { operationCode: '89686' }
  ],
  [
    VehicleAccidentsOperationId.otros_OB_comunicacion_telefonica,
    { operationCode: '89687' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_no_conoce_matricula,
    { operationCode: '89690' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_fallo_en_geolocalizacion,
    { operationCode: '89691' }
  ],
  [
    VehicleAccidentsOperationId.parte_OE_error_seleccion_piezas,
    { operationCode: '89692' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_datos_vehiculo_contrario,
    { operationCode: '89693' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_vehiculo_no_encontrado_id_vehiculo,
    { operationCode: '89694' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_fallo_obtencion_companias,
    { operationCode: '89695' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_datos_circunstancias,
    { operationCode: '89696' }
  ],
  [
    VehicleAccidentsOperationId.parte_OB_colision_un_vehiculo,
    { operationCode: '89697' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_fallo_guarda,
    { operationCode: '89854' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_retoma_parte,
    { operationCode: '89855' }
  ]
];

const BUSINESS_VEHICLE_ACCIDENTS_OPERATIONS: [
  VehicleAccidentsOperationId,
  { operationCode: string }
][] = [
  [
    VehicleAccidentsOperationId.seleccion_lunas,
    { operationCode: '158513' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_sin_contrario,
    { operationCode: '158514' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_con_contrario,
    { operationCode: '158515' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_danos_cargador,
    { operationCode: '159371' }
  ],
  [
    VehicleAccidentsOperationId.inicio,
    { operationCode: '158081' }
  ],
  [
    VehicleAccidentsOperationId.tipo_no_disponible,
    { operationCode: '158084' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_tipo,
    { operationCode: '158085' }
  ],
  [
    VehicleAccidentsOperationId.prestamo,
    { operationCode: '158510' }
  ],
  [
    VehicleAccidentsOperationId.guardar,
    { operationCode: '158511' }
  ],
  [
    VehicleAccidentsOperationId.abandono_sin_contrario,
    { operationCode: '158512' }
  ],
  [
    VehicleAccidentsOperationId.otros_danos_presentes,
    { operationCode: '158516' }
  ],
  [
    VehicleAccidentsOperationId.danos_solo_vehiculo,
    { operationCode: '158517' }
  ],
  [
    VehicleAccidentsOperationId.golpe_unico,
    { operationCode: '158518' }
  ],
  [
    VehicleAccidentsOperationId.golpes_acumulados,
    { operationCode: '158519' }
  ],
  [
    VehicleAccidentsOperationId.datos_generales_siniestro,
    { operationCode: '158520' }
  ],
  [
    VehicleAccidentsOperationId.datos_danos_vehiculo,
    { operationCode: '158521' }
  ],
  [
    VehicleAccidentsOperationId.datos_danos_adicionales,
    { operationCode: '158522' }
  ],
  [
    VehicleAccidentsOperationId.resumen_datos,
    { operationCode: '158523' }
  ],
  [
    VehicleAccidentsOperationId.datos_contacto,
    { operationCode: '158524' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_tipo_taller_continuo,
    { operationCode: '158525' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_tipo_taller_diferido,
    { operationCode: '158557' }
  ],
  [
    VehicleAccidentsOperationId.centro_servicio_continuo,
    { operationCode: '158527' }
  ],
  [
    VehicleAccidentsOperationId.centro_servicio_diferido,
    { operationCode: '158543' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_vehiculo_cortesia_ok_continuo,
    { operationCode: '158537' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_vehiculo_cortesia_ok_diferido,
    { operationCode: '158555' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_pendiente_confirmacion_culpa_ok_continuo,
    { operationCode: '158906' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_pendiente_confirmacion_culpa_ok_diferido,
    { operationCode: '158908' }
  ],
  [
    VehicleAccidentsOperationId.taller_distinguido_continuo,
    { operationCode: '158528' }
  ],
  [
    VehicleAccidentsOperationId.taller_distinguido_diferido,
    { operationCode: '158544' }
  ],
  [
    VehicleAccidentsOperationId.otro_taller_continuo,
    { operationCode: '158530' }
  ],
  [
    VehicleAccidentsOperationId.otro_taller_diferido,
    { operationCode: '158546' }
  ],
  [
    VehicleAccidentsOperationId.abandono_reparacion,
    { operationCode: '158559' }
  ],
  [
    VehicleAccidentsOperationId.ro_op_024,
    { operationCode: '158529' }
  ],
  [
    VehicleAccidentsOperationId.ro_op_044,
    { operationCode: '158545' }
  ],
  [
    VehicleAccidentsOperationId.sin_contrario_OB_aparcamiento_ok,
    { operationCode: '158536' }
  ],
  [
    VehicleAccidentsOperationId.sin_contrario_OB_circulacion_ok,
    { operationCode: '158535' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_ok_continuo,
    { operationCode: '158539' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_otro_taller_ok_continuo,
    { operationCode: '158542' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_taller_pap_ok_continuo,
    { operationCode: '158541' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_taller_distinguido_ok_continuo,
    { operationCode: '158540' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_ok_diferido,
    { operationCode: '158547' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_otro_taller_ok_diferido,
    { operationCode: '158553' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_taller_pap_ok_diferido,
    { operationCode: '158551' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_taller_distinguido_ok_diferido,
    { operationCode: '158549' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OB_centro_servicio_vehiculo_cortesia_ok_diferido,
    { operationCode: '158555' }
  ],

  [
    VehicleAccidentsOperationId.lunas_OB_contacto_enviado_ok,
    { operationCode: '158027' }
  ],
  [
    VehicleAccidentsOperationId.sin_contrario_OI_pdf_ko,
    { operationCode: '158561' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OI_poliza_no_en_vigor,
    { operationCode: '158400' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OI_siniestro_existe_a_fecha,
    { operationCode: '158401' }
  ],
  [
    VehicleAccidentsOperationId.OE_error_servicio,
    { operationCode: '158083' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_ko_continuo,
    { operationCode: '158531' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_ko_diferido,
    { operationCode: '158548' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_vehiculo_cortesia_ko_continuo,
    { operationCode: '158556' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_vehiculo_cortesia_ko_diferido,
    { operationCode: '158538' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_pendiente_confirmacion_culpa_ko_continuo,
    { operationCode: '158907' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_centro_servicio_pendiente_confirmacion_culpa_ko_diferido,
    { operationCode: '158909' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_otro_taller_ko_continuo,
    { operationCode: '158534' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_otro_taller_ko_diferido,
    { operationCode: '158554' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_taller_distinguido_ko_continuo,
    { operationCode: '158532' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_taller_distinguido_ko_diferido,
    { operationCode: '158550' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_taller_pap_ko_continuo,
    { operationCode: '158533' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_taller_pap_ko_diferido,
    { operationCode: '158552' }
  ],
  [
    VehicleAccidentsOperationId.OE_apertura_ko,
    { operationCode: '158560' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_motor_reglas_ko_continuo,
    { operationCode: '159151' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_motor_reglas_ko_diferido,
    { operationCode: '159150' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_seleccion_tipo_taller_ko_continuo,
    { operationCode: '158526' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_seleccion_tipo_taller_ko_diferido,
    { operationCode: '158558' }
  ],
  [
    VehicleAccidentsOperationId.sin_contrario_OE_error_generico,
    { operationCode: '158507' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OE_servicio_balanceo_ko,
    { operationCode: '158026' }
  ],
  [
    VehicleAccidentsOperationId.lunas_OE_error_contacto_enviado,
    { operationCode: '158028' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_OE_error_generico,
    { operationCode: '158506' }
  ],
  [
    VehicleAccidentsOperationId.danos_cargador_OB_ok,
    { operationCode: '159372' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_pap_distinguido_sin_servicio,
    { operationCode: '159592' }
  ],
  [
    VehicleAccidentsOperationId.reparacion_pap_continuo_sin_servicio,
    { operationCode: '159593' }
  ],
  [
    VehicleAccidentsOperationId.seleccion_otros,
    { operationCode: '89686' }
  ],
  [
    VehicleAccidentsOperationId.otros_OB_comunicacion_telefonica,
    { operationCode: '89687' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_fallo_en_geolocalizacion,
    { operationCode: '89691' }
  ],
  [
    VehicleAccidentsOperationId.parte_OE_error_seleccion_piezas,
    { operationCode: '89692' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_datos_vehiculo_contrario,
    { operationCode: '89693' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_vehiculo_no_encontrado_id_vehiculo,
    { operationCode: '89694' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_fallo_obtencion_companias,
    { operationCode: '89695' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_datos_circunstancias,
    { operationCode: '89696' }
  ],
  [
    VehicleAccidentsOperationId.parte_OB_colision_un_vehiculo,
    { operationCode: '89697' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_fallo_guarda,
    { operationCode: '159854' }
  ],
  [
    VehicleAccidentsOperationId.parte_OI_retoma_parte,
    { operationCode: '159855' }
  ]
];

export function getVAOperationsMap() {
  return new Map<VehicleAccidentsOperationId, {
    operationCode: string,
  }>(VEHICLE_ACCIDENTS_OPERATIONS);
}

export function getBusinessVAOperationsMap() {
  return new Map<VehicleAccidentsOperationId, {
    operationCode: string,
  }>(BUSINESS_VEHICLE_ACCIDENTS_OPERATIONS);
}
